import React, { useState } from "react"
import { Button, Input, Modal, Typography, message } from "antd"
import { CloseCircleFilled } from "@ant-design/icons"
import { doc, serverTimestamp, updateDoc } from "firebase/firestore"
import { db } from "../../../../firebase/config"
import { useAuthContext } from "../../../../hooks/useAuthContext"

const { Text } = Typography
const { TextArea } = Input

const StopOrderPaperManager = (props) => {
  //gets users
  const { user } = useAuthContext()
  const [stopComment, setStopComment] = useState(null)

  const [isModalOpen, setIsModalOpen] = useState(false)
  const showModal = () => {
    setIsModalOpen(true)
    console.log(props.data)
  }
  const handleOk = async () => {
    stopTheOrder()
  }

  const cancel = () => {
    setIsModalOpen(false)
  }

  //update stop order
  const stopTheOrder = async () => {
    const ref = doc(db, "orders", props.data.id)
    try {
      await updateDoc(ref, {
        orderStatus: 999,
        requestedToStop: false,
        orderStopped: serverTimestamp(),
        stoppedBy: user.email,
        stopRequestComment: stopComment,
      })
    } catch (error) {
      message.error("error happened")
      console.log(error)
    } finally {
      message.success("updated")
      setIsModalOpen(false)
    }
  }

  return (
    <>
      <Button
        onClick={showModal}
        ghost
        block
        type="primary"
        icon={<CloseCircleFilled style={{ color: "#f5222d" }} />}>
        Stop Order
      </Button>
      <Modal
        title="Fill Stop request"
        okText="Stop The Order"
        cancelText="Cancel"
        open={isModalOpen}
        onCancel={cancel}
        onOk={handleOk}>
        <TextArea
          rows={4}
          value={stopComment}
          placeholder="Type your stop comment"
          onChange={(event) => setStopComment(event.target.value)}
        />
        <Text>{props.data.stopRequestComment}</Text>
      </Modal>
    </>
  )
}

export default StopOrderPaperManager
